// src/components/Review.jsx
import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { FaStar } from "react-icons/fa";

const guestImages = [
  `${process.env.PUBLIC_URL}/images/guests/WhatsApp Image 2026-05-12 at 12.28.30.jpeg`,
  `${process.env.PUBLIC_URL}/images/guests/WhatsApp Image 2026-05-12 at 12.28.30 (1).jpeg`,
  `${process.env.PUBLIC_URL}/images/guests/WhatsApp Image 2026-05-12 at 12.28.30 (2).jpeg`,
  `${process.env.PUBLIC_URL}/images/guests/WhatsApp Image 2026-05-12 at 12.58.56.jpeg`,
  `${process.env.PUBLIC_URL}/images/guests/WhatsApp Image 2026-05-12 at 12.28.30 (3).jpeg`,
  `${process.env.PUBLIC_URL}/images/guests/WhatsApp Image 2026-05-12 at 12.28.31.jpeg`,
  `${process.env.PUBLIC_URL}/images/guests/WhatsApp Image 2026-05-12 at 12.28.31 (1).jpeg`,
  `${process.env.PUBLIC_URL}/images/guests/WhatsApp Image 2026-05-12 at 12.28.31 (2).jpeg`,
  `${process.env.PUBLIC_URL}/images/guests/WhatsApp Image 2026-05-12 at 12.29.40.jpeg`,
  `${process.env.PUBLIC_URL}/images/guests/WhatsApp Image 2026-05-12 at 12.29.40 (1).jpeg`,
  `${process.env.PUBLIC_URL}/images/guests/WhatsApp Image 2026-05-12 at 12.35.37.jpeg`,
  `${process.env.PUBLIC_URL}/images/guests/WhatsApp Image 2026-05-12 at 12.35.38.jpeg`,
  `${process.env.PUBLIC_URL}/images/guests/WhatsApp Image 2026-05-12 at 12.58.57 (2).jpeg`,
];

const reviews = [
  {
    name: "Arlind Drabo",
    comment: "Very professional service! Will definitely come back again.",
    date: "August 2025",
  },
  {
    name: "bernard stafa",
    comment: "The Speed boat was pure adrenaline ⚡️💪recomend 💯",
    date: "July 2025",
  },
  {
    name: "Tony Amsterdam",
    comment: "Qua troverete tutto... siete i migliori 🙏💪💪💪",
    date: "June 2025",
  },
  {
    name: "Alfons Shqypi",
    comment: "The Boat ride was the best experince i had in Albania.",
    date: "June 2025",
  },
  {
    name: "First Game",
    comment: "It was the best boat adventure I've had.",
    date: "July 2025",
  },
  {
    name: "Христина Марусяк",
    comment:
      "I had a fantastic experience with this travel company! Highly recommended!",
    date: "August 2025",
  },
  {
    name: "Iva Godole",
    comment: "It was a great adventure🤩🤩🤩 Very nice",
    date: "July 2025",
  },
  {
    name: "Orgen Shqypi",
    comment: "It was perfect",
    date: "June 2025",
  },
];

const Review = () => {
  return (
    <div className="py-10 md:py-16 bg-white dark:from-gray-900 dark:via-gray-800 dark:to-gray-900">
      <div className="max-w-6xl mx-auto px-4">
        {/* Header */}
        <div className="text-center mb-6 md:mb-10">
          <h2 className="text-2xl sm:text-4xl md:text-5xl font-extrabold bg-gradient-to-r from-blue-600 to-cyan-600 bg-clip-text text-transparent mb-2 md:mb-4">
            What Our Guests Say
          </h2>
          <p className="hidden sm:block text-gray-600 dark:text-gray-300 text-sm sm:text-base md:text-lg max-w-2xl mx-auto px-2">
            Real experiences from travelers who explored Albania's waters with
            us
          </p>
        </div>

        {/* Reviews Slider */}
        <Swiper
          modules={[Autoplay, Pagination]}
          autoplay={{ delay: 4000, disableOnInteraction: false }}
          pagination={{
            clickable: true,
            dynamicBullets: true,
            bulletClass: "swiper-pagination-bullet",
            bulletActiveClass: "swiper-pagination-bullet-active",
          }}
          spaceBetween={16}
          slidesPerView={1}
          breakpoints={{
            640: { slidesPerView: 1, spaceBetween: 20 },
            768: { slidesPerView: 2, spaceBetween: 24 },
            1024: { slidesPerView: 3, spaceBetween: 30 },
          }}
          loop={true}
          className="pb-10 md:pb-12"
        >
          {reviews.map((review, index) => (
            <SwiperSlide key={index}>
              <div className="bg-white dark:bg-gray-800 rounded-lg sm:rounded-xl shadow-md hover:shadow-xl p-4 sm:p-5 md:p-6 h-full border border-gray-100 dark:border-gray-700 hover:border-cyan-400 dark:hover:border-cyan-600 transition-all duration-300">
                {/* Stars and Date */}
                <div className="flex items-center justify-between mb-3 sm:mb-4">
                  <div className="flex gap-0.5 sm:gap-1">
                    {[...Array(5)].map((_, i) => (
                      <FaStar
                        key={i}
                        className="text-yellow-400 text-xs sm:text-sm md:text-base"
                      />
                    ))}
                  </div>
                  <span className="hidden sm:inline-block text-xs text-gray-500 dark:text-gray-400 font-medium bg-gray-100 dark:bg-gray-700 px-2.5 py-1 rounded-full">
                    {review.date}
                  </span>
                </div>

                {/* Comment */}
                <p className="text-gray-700 dark:text-gray-300 text-xs sm:text-sm leading-relaxed mb-4 sm:mb-5 italic line-clamp-3 sm:line-clamp-none sm:min-h-[60px]">
                  "{review.comment}"
                </p>

                {/* User Info */}
                <div className="flex items-center gap-2.5 sm:gap-3 pt-3 sm:pt-4 border-t border-gray-200 dark:border-gray-700">
                  <div className="w-9 h-9 sm:w-10 sm:h-10 rounded-full bg-gradient-to-r from-cyan-500 to-blue-600 flex items-center justify-center text-white font-bold text-sm sm:text-base flex-shrink-0">
                    {review.name.charAt(0)}
                  </div>
                  <div className="min-w-0 flex-1">
                    <h4 className="font-bold text-gray-900 dark:text-white text-sm sm:text-base truncate">
                      {review.name}
                    </h4>
                    <p className="text-[10px] sm:text-xs text-gray-500 dark:text-gray-400">
                      Verified Guest
                    </p>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        {/* Guest Photos Gallery */}
        <div className="mt-10 md:mt-14">
          <h3 className="text-center text-lg sm:text-xl font-bold text-gray-700 dark:text-gray-300 mb-5">
            📸 Moments from Our Guests
          </h3>
          <div className="relative">
            <Swiper
              modules={[Autoplay, Navigation, Pagination]}
              autoplay={{ delay: 3000, disableOnInteraction: false }}
              navigation={true}
              pagination={{ clickable: true, dynamicBullets: true }}
              spaceBetween={12}
              slidesPerView={1}
              breakpoints={{
                480: { slidesPerView: 2, spaceBetween: 12 },
                768: { slidesPerView: 3, spaceBetween: 16 },
                1024: { slidesPerView: 4, spaceBetween: 16 },
              }}
              loop={true}
              className="pb-10"
            >
              {guestImages.map((src, i) => (
                <SwiperSlide key={i}>
                  <div className="rounded-xl overflow-hidden aspect-square shadow-md hover:shadow-xl transition-shadow duration-300">
                    <img
                      src={src}
                      alt={`Guest moment ${i + 1}`}
                      className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
                      loading="lazy"
                    />
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Review;
